import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("fb_token"));
  const [loading, setLoading] = useState(true);

  const axiosAuth = useCallback(() => {
    return axios.create({
      baseURL: API,
      withCredentials: true,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  }, [token]);

  useEffect(() => {
    const check = async () => {
      if (!token) { setLoading(false); return; }
      try {
        const res = await axios.get(`${API}/auth/me`, {
          withCredentials: true,
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(res.data);
      } catch {
        setUser(null);
        setToken(null);
        localStorage.removeItem("fb_token");
      } finally {
        setLoading(false);
      }
    };
    check();
  }, [token]);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
    const { token: t, ...userData } = res.data;
    setToken(t);
    setUser(userData);
    localStorage.setItem("fb_token", t);
    return userData;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true, headers: { Authorization: `Bearer ${token}` } });
    } catch {}
    setUser(null);
    setToken(null);
    localStorage.removeItem("fb_token");
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, logout, axiosAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export default AuthContext;
